<template>
    <div class=" my">
        <img src="../../assets/logotable.png" style="position:fixed;top:0.8rem;z-index:9;height:1.5rem;right:50vw;">
        <nav-bar title="经费申请"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft"
                 class="my-nav">
        </nav-bar>
        <div style="margin-top: 2.9rem"></div>


        <cell-group :title="activityName">
            <cell v-for="(v,i) in list" :key="i" :title="v.details" :value="v.rental+'元'"/>
            <!-- 分页-->
            <pagination v-model="page" :total-items="total" mode="simple" @change="init()" v-if="list.length"/>
            <empty v-else description="暂无数据"/>
        </cell-group>

        <ant-form validate-first @submit="onSubmit">

            <div v-for="(v,i) in forms" :key="i" style="margin: 1rem">
                <ant-row type="flex" justify="end" style="margin-bottom: 10px">
                    <ant-button type="danger" size="mini" round @click="clearForm(i)"
                                v-if="i!= 0">删除
                    </ant-button>
                    <ant-button type="info" size="mini" round @click="clickRightIcon(i)" v-if="i== forms.length-1">增加
                    </ant-button>
                </ant-row>

                <ant-field label="经费类型："
                           v-model="v.details"
                           required
                           :rules="[{ required: true , message: '请填写经费类型' }]"
                           placeholder="请输入内容"/>
                <!-- 允许输入数字，调起全键盘 -->
                <ant-field v-model="v.rental" type="number" required label="经费金额" style="margin-bottom: 1rem"/>
            </div>

            <div style="margin: 16px;">
                <ant-button round block type="danger" native-type="submit" :loading="loading" :disabled="disabled">
                    提交审批
                </ant-button>
            </div>
        </ant-form>
    </div>
</template>

<script>
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row, Pagination, Dialog, Icon, SwipeCell, Empty
    } from 'vant'
    import service from "../../api/service";
    //经费申请
    export default {
        name: "fundApplication",
        components: {
            Cell,
            CellGroup,
            NavBar,
            Divider,
            AntButton: Button,
            AntForm: Form,
            AntField:
            Field,
            DatetimePicker,
            Popup,
            Collapse,
            CollapseItem,
            AntCol: Col,
            AntRow: Row,
            Pagination,
            Dialog,
            Icon, SwipeCell, Empty
        },
        data() {
            return {
                loading: false,
                disabled: false,
                id: '-',
				distinguish:"",
				approvalpersons: [],
				approvalpersonsname: "",
                activityName: '',
                activeNames: [],
                list: [],
                page: 1,
                total: 0,
                forms: [{
                    activityId: this.$route.query.id,
                    deptBunch: sessionStorage.getItem("deptId"),
                    details: '',
                    rental: 0
                }],
            }
        },
        mounted() {
            this.id = this.$route.query.id
            this.distinguish = this.$route.query.distinguish
            this.activityName = this.$route.query.activityName
            this.init()
        },
        methods: {
            init() {
				let _deptId = sessionStorage.getItem("deptId");
				let _jtdeptId = "";
				if(this.distinguish == "1"){
					if(_deptId.indexOf(",") > 0){
						_jtdeptId = _deptId.substring(0,(_deptId.indexOf(",")));
					}else{
						_jtdeptId = _deptId;
					}
				}else{
					_jtdeptId = _deptId;
				}
				service
				  .get("/system/app-user/queryApproverUserByDeptId", {
				    deptId: _jtdeptId,
					modCode:"budgetApproval"
				  })
				  .then((res) => {
				    if (res.status === 200) {
				      // let arr = [];
				      // res.data.forEach((v) => {
				      //   arr.push(v.userName);
				      // });
					  this.approvalpersons = res.data.filter(function (s) {
					      return s.id != sessionStorage.getItem("id"); 
					  });
					  this.approvalpersonsname=this.approvalpersons.map(item=>{
					      return item.userName;
					    }).join(",");
				    }
				  });
				
                service.post('/api/activity-creation-approval/querysumbyid', {
                    activityId: this.$route.query.id,
                    page: this.page,
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                        this.total = res.total
                    }
                })
            },
            onClickLeft() {
                this.$router.push({path: '/launchEvent'})
            },
            //提交
            onSubmit() {
				let _deptId = sessionStorage.getItem("deptId");
				let _jtdeptId = "";
				if(this.distinguish == "1"){
					if(_deptId.indexOf(",") > 0){
						_jtdeptId = _deptId.substring(0,(_deptId.indexOf(",")));
					}else{
						_jtdeptId = _deptId;
					}
				}else{
					_jtdeptId = _deptId;
				}
				
                Dialog.confirm({
                    title: '确定提交',
                    message: "提交经费审核,此条审核将会推送给\r\n"+this.approvalpersonsname,
                }).then(v => {
                    let forms = [...this.forms]
                    this.loading = true
                    this.disabled = true
                    service.post('/api/activity-creation-approval/saveperform', {
                        sxBusinessBudgets: forms,
                        deptId: _jtdeptId,
                        userId: sessionStorage.getItem("id"),
                    }).then(res => {
                        this.loading = false
                        if (res.status === 200) {
                            Toast.success(res.message)
                            this.init()
                        } else {
                            Toast.fail(res.message)
                        }
                    })
                })
            },
            clickRightIcon(i) {
                this.forms.push({
                    activityId: this.id,
                    deptBunch: sessionStorage.getItem("deptId"),
                    details: '',
                    rental: 0
                })
            },
            //删除
            clearForm(i) {
                this.forms.splice(i, 1);
            }
        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }


</style>